import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from 'react';
import AdminLayout from '../../Components/Admin/AdminLayout';
// eslint-disable-next-line no-unused-vars
import { Container, Row, Col, Card, CardHeader, CardBody, Table, Button, Alert, Spinner, Badge, Input, FormGroup, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line no-unused-vars
import { faSync, faSearch, faCreditCard } from '@fortawesome/free-solid-svg-icons';
const API_BASE = window.HMI_API_BASE || process.env.REACT_APP_API_URL || 'https://api.heresmyinfo.com/api';
export default function Payments() {
  const {
    t
  } = useTranslation();
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const token = localStorage.getItem('token') || localStorage.getItem('accessToken') || '';

  const fetchPayments = async () => {
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE}/admin/payments`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      const data = await response.json();

      if (data.success) {
        setPayments(data.data || []);
      } else {
        setError(data.error?.message || 'Failed to fetch payments data');
      }
    } catch (err) {
      console.error('Error fetching payments:', err);
      setError('Connection error loading payments data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formatDate = dateString => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };

  const filteredPayments = payments.filter(p => {
    const query = searchQuery.toLowerCase();
    return p.id.toLowerCase().includes(query) || p.client_name.toLowerCase().includes(query) || p.client_id.toLowerCase().includes(query) || p.provider.toLowerCase().includes(query);
  });
  return <AdminLayout>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col md={8}>
            <h2>{t("Transaction & Payments History")}</h2>
            <p className="text-muted">{t("Monitor client subscription charges and Stripe transactions.")}</p>
          </Col>
          <Col md={4} className="text-right">
            <Button color="primary" onClick={fetchPayments} disabled={loading}>
              <FontAwesomeIcon icon={faSync} className={`mr-2 ${loading ? 'fa-spin' : ''}`} />{t("Refresh")}</Button>
          </Col>
        </Row>

        {error && <Alert color="danger">{error}</Alert>}

        <Row className="mb-4">
          <Col md={12}>
            <Card>
              <CardHeader className="d-flex justify-content-between align-items-center">
                <span className="font-weight-bold">
                  <FontAwesomeIcon icon={faCreditCard} className="mr-2 text-primary" />{t("All Payments (")}{filteredPayments.length})
                </span>
                <div style={{
                width: '300px'
              }}>
                  <Input type="text" placeholder={t("Search by client, ID, provider...")} value={searchQuery} onChange={e => setSearchQuery(e.target.value)} />
                </div>
              </CardHeader>
              <CardBody>
                {loading ? <div className="text-center py-5">
                    <Spinner color="primary" />
                    <p className="mt-2 text-muted">{t("Fetching transaction records...")}</p>
                  </div> : <Table responsive striped hover className="align-middle">
                    <thead>
                      <tr>
                        <th>{t("Transaction ID")}</th>
                        <th>{t("Client Name")}</th>
                        <th>{t("Client ID")}</th>
                        <th>{t("Amount")}</th>
                        <th>{t("Provider")}</th>
                        <th>{t("Status")}</th>
                        <th>{t("Created At")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredPayments.length === 0 ? <tr>
                          <td colSpan="7" className="text-center py-4 text-muted">{t("No payment transactions found.")}</td>
                        </tr> : filteredPayments.map(payment => <tr key={payment.id}>
                            <td><code>{payment.id}</code></td>
                            <td><strong>{payment.client_name}</strong></td>
                            <td><small className="text-muted text-monospace">{payment.client_id}</small></td>
                            <td>
                              <span className="font-weight-bold text-success">
                                ${payment.amount.toFixed(2)}
                              </span>{' '}
                              <span className="text-muted text-uppercase" style={{
                        fontSize: '12px'
                      }}>
                                {payment.currency}
                              </span>
                            </td>
                            <td>{payment.provider}</td>
                            <td>
                              <Badge color={payment.status === 'succeeded' ? 'success' : 'danger'}>
                                {payment.status}
                              </Badge>
                            </td>
                            <td>{formatDate(payment.created_at)}</td>
                          </tr>)}
                    </tbody>
                  </Table>}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </AdminLayout>;
}